const resourcePaginate = document.querySelector('[data-paginate]');
if (resourcePaginate) {
  if (resourcePaginate.dataset.type === 'click') resourcePaginate.addEventListener('click', paginateByClick);
  if (resourcePaginate.dataset.type === 'scroll') paginateByScroll(resourcePaginate);
}

async function paginateByClick(event) {
  event.preventDefault();
  const trigger = this;
  trigger.disabled = true;
  trigger.classList.add('cursor-wait');
  const triggerParent = document.querySelector(trigger.dataset.parentElement)
    ? document.querySelector(trigger.dataset.parentElement)
    : trigger.parentElement;
  const insertMethod = trigger.dataset.hasOwnProperty('insertMethod') ? trigger.dataset.insertMethod : 'append';
  const page = await paginateResource(trigger, insertMethod, triggerParent);
  trigger.blur();
  trigger.disabled = false;
  trigger.classList.remove('cursor-wait');
  if (!page || !page.next) triggerParent.parentElement.removeChild(triggerParent);
}

function paginateByScroll(trigger) {
  const observerOptions = {
    threshold: 1,
  };
  const observer = new IntersectionObserver((entries, thisObserver) => {
    entries.forEach(async function (entry) {
      if (!entry.isIntersecting) return;
      const target = entry.target;
      const triggerParent = document.querySelector(trigger.dataset.parentElement)
        ? document.querySelector(trigger.dataset.parentElement)
        : trigger.parentElement;
      const insertMethod = trigger.dataset.hasOwnProperty('insertMethod') ? trigger.dataset.insertMethod : 'append';
      const page = await paginateResource(target, insertMethod, triggerParent);
      if (!page || !page.next) {
        target.parentElement.removeChild(target);
        thisObserver.unobserve(target);
      }
    });
  }, observerOptions);

  observer.observe(trigger);
}

async function paginateResource(trigger, insertMethod, beforeElement = null) {
  if (trigger.dataset.paginate === '') return false;
  const url = trigger.dataset.paginate + '&section_id=' + trigger.dataset.section;
  const page = await fetchNextPage(url);
  if (!page || !page.items) return false;

  const itemList = document.querySelector(trigger.dataset.listSelector);
  const allCurrencyOutputs = [];
  page.items.forEach((item) => {
    if (insertMethod === 'append') itemList.appendChild(item);
    if (insertMethod === 'insertBefore' && beforeElement) itemList.insertBefore(item, beforeElement);
    const currencyOutputs = item.querySelectorAll('[data-money]');
    if (currencyOutputs && currencyOutputs.length) currencyOutputs.forEach((output) => allCurrencyOutputs.push(output));
    modifyPaginatedItem(item);
  });
  trigger.dataset.paginate = page.next ? page.next : '';
  if (allCurrencyOutputs.length) {
    document.body.dispatchEvent(
      new CustomEvent('CurrencyConverterUpdate', {
        detail: { outputs: allCurrencyOutputs },
      })
    );
  }

  return page;
}

async function fetchNextPage(url) {
  const promise = await attemptFetch('resource pagination', url);
  if (!promise) return false;
  const data = await promise.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, 'text/html');
  const items = doc.querySelectorAll('[data-pagination-item]');
  const paginate = doc.querySelector('[data-paginate]');
  const page = {
    items: items && items.length ? items : false,
    next: paginate ? paginate.dataset.paginate : false,
  };
  return page;
}

function modifyPaginatedItem(item) {
  const addToCartForm = item.querySelector('[data-add_to_cart_drawer]');
  handleAddToCartDrawer(addToCartForm);
}
